<!--
    @修改人：黎柏祺
    @修改时间：2018-12-11
    @修改描述：框架升级
    @版本:v1.0.26
    ------------
    @修改人: libaiqi
    @创建时间: 2018-08-23
    @版本:v1.0.21
    @修改描述:新增告警规则
    --------------
    @负责人: 谢汉
    @创建时间: 2018-01-18
    @版本:v1.0.12
    @描述: 告警订阅页
    -->
<template>
  <div class="alaramSubscribe__content">
    <div>
      <el-form ref="form"
        :model="form"
        :inline="true"
        input-width="auto">
        <el-form-item :label="$t('alarmSubscribe.name')">
          <el-input v-model="form.userName"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
            @click="e_search"
            v-g-rac="gRac('alarmSubScribe_search')">{{ $t('common.search') }}</el-button>
          <el-button type="primary"
            @click="e_edit()"
            v-g-rac="gRac('alarmSubScribe_addUser')">{{ $t('alarmSubscribe.addSubscribe') }}</el-button>
          <el-button type="primary"
            @click="groupManage"
            v-g-rac="gRac('alarmSubScribe_userGroup')">{{ $t('alarmSubscribe.groupManage') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <el-table-extend :data="tData"
        :head="tHead"
        :currentChange="tCurrentChange"
        :sizeChange="tSizeChange"
        border>
        <template slot="control-column"
          slot-scope="{data}">
          <el-table-extend-control :control="tableControl"
            :data="data"
            :label="$t('common.handle')">
          </el-table-extend-control>
        </template>
      </el-table-extend>
    </div>
    <el-dialog :closeOnClickModal="false"
      :title="dialogTitle"
      :visible.sync="dialogFormVisible">
      <el-form :model="subScribeForm"
        label-position="right"
        label-width="100px"
        ref="subScribeForm"
        :rules="rules">
        <el-form-item :label="$t('alarmSubscribe.name')"
          prop="userName">
          <el-input v-model="subScribeForm.userName"
            :disabled="isDisabled"></el-input>
        </el-form-item>
        <el-form-item :label="$t('alarmSubscribe.groups')"
          input-width="auto">
          <el-checkbox-group v-model="subScribeForm.groups">
            <el-checkbox v-for="(item, key) in select_gourps"
              :label="item"
              :key="key"
              class="alarmSubscribe__checkItem"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item :label="$t('alarmSubscribe.mail')"
          prop="email">
          <el-input v-model="subScribeForm.email"></el-input>
        </el-form-item>
        <el-form-item :label="$t('alarmSubscribe.phone')"
          prop="phone">
          <el-input v-model="subScribeForm.phone"></el-input>
        </el-form-item>
        <el-form-item :label="$t('alarmSubscribe.notifyMode')"
          input-width="auto">
          <el-checkbox-group v-model="subScribeForm.notifyMode">
            <el-checkbox v-for="(item, key) in notifyMode"
              :label="key"
              :key="key"
              class="alarmSubscribe__checkItem">{{item}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item :label="$t('alarmSubscribe.enable')">
          <el-radio-group v-model="subScribeForm.enable">
            <el-radio :label="index"
              v-for="(item,index) in enable"
              :key="index">{{item}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- <el-form-item :label="$t('alarmSubscribe.alarmLevelNotify')" input-width="auto">
          <dynamic-table 
            ref="dynamicTable" 
            :input-data="inputData" 
            :model="tableModel" 
            :custom-fun="deleteDdata">
          </dynamic-table>
        </el-form-item>
        <el-form-item :label="$t('alarmSubscribe.remarks')" >
          <el-input type="textarea" v-model="subScribeForm.remarks" :autosize="{ minRows: 5}"></el-input>
        </el-form-item> -->
      </el-form>
      <div slot="footer"
        class="dialog-footer">
        <el-button @click="resetForm">{{$t('common.cancel')}}</el-button>
        <el-button type="primary"
          @click="e_save"
          v-g-rac="gRac('alarmSubScribe_addUser')">{{$t('common.save')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import rac from "@/plugins/rac-mixin";
import dic from "@/components/mixins/dic";
import table from "@/components/mixins/table";
import AlarmSubscribeBiz from "@/logic/systemSetting/systemSettingBiz";
import { extend, getKeyByValue } from "@/utils/tool";
import validateConfig from "@/utils/validate";
// import dynamicTable from "@/components/dynamicTable";
export default {
  mixins: [rac, dic, table],
  components: {
    // dynamicTable
  },
  data() {
    const that = this;
    return {
      form: {
        userName: ""
      },
      tableControl: [
        {
          label: that.$t("common.edit"),
          callback: that.e_edit,
          rac: () => that.gRac("alarmSubScribe_amend")
        },
        {
          label: that.$t("common.delete"),
          callback: that.e_delete,
          rac: () => that.gRac("alarmSubScribe_delete")
        }
      ],
      notifyMode: {},
      enable: {},
      select_gourps: {},
      alarmType: {},
      select_alarmLevel: {},
      dialogFormVisible: false,
      dialogTitle: "",
      rules: {
        userName: [{ ...validateConfig.common.notEmpty }],
        email: [{ ...validateConfig.common.notEmpty }],
        phone: [{ ...validateConfig.common.notEmpty }]
      },
      subScribeForm: {
        userName: "",
        email: "",
        phone: "",
        notifyMode: [],
        enable: "true",
        // remarks: "",
        groups: []
      },
      inputData: [],
      tableModel: {},
      isAmend: false,
      isDisabled: false
    };
  },
  methods: {
    e_init() {
      this.enable = {
        true: this.$t("alarmSubscribe.yes"),
        false: this.$t("alarmSubscribe.no")
      };
      this.preInitTable();
    },
    async preInitTable() {
      await Promise.all([
        this.dGetDictionaryByCode("modelType"),
        this.dGetDictionaryByCode("alarmType"),
        this.dGetDictionaryByCode("alarmLevel")
      ]).then(() => {
        this.notifyMode = { ...this.dDictionary.modelType };
        this.alarmType = { ...this.dDictionary.alarmType };
        this.select_alarmLevel = { ...this.dDictionary.alarmLevel };
        this.initTable();
        this.setDynamicData();
        this.search();
      });
    },
    initTable() {
      this.tInitTable({
        lanKey: "alarmSubscribe.table",
        head: ["userName", "email", "phone", "notifyMode", "enable", "remarks"],
        requestFun: this.search,
        headOpt: {}
      });
    },
    setDynamicData() {
      this.inputData = [
        {
          label: this.$t("alarmSubscribe.alarmLevel"),
          key: "alarmLevel",
          type: "select",
          select: this.select_alarmLevel
        },
        {
          label: this.$t("alarmSubscribe.notifyMode"),
          key: "notifyMode",
          type: "checkboxGroup",
          select: this.notifyMode
        }
      ];
      this.tableModel = {
        alarmLevel: Object.keys(this.select_alarmLevel)[0],
        notifyMode: []
      };
    },
    groupManage() {
      this.$router.push({ name: "alarmSubscribeEdit" });
    },
    // deleteDdata(item, index) {
    //   const dData = this.$refs.dynamicTable.getData();
    //   dData.splice(index, 1);
    //   this.$refs.dynamicTable.setData(dData);
    // },
    resetForm() {
      this.$refs.subScribeForm.resetFields();
      this.dialogFormVisible = false;
    },
    search() {
      const reqData = extend(true, { ...this.tPageInfo }, this.form);
      AlarmSubscribeBiz.getSubscribe(reqData)
        .then(data => {
          data.dataList.map(item => {
            if (item.enable) {
              item.enable = this.$t("alarmSubscribe.yes");
            } else {
              item.enable = this.$t("alarmSubscribe.no");
            }
            let notifyStr = "";
            item.notifyMode.forEach(i => {
              notifyStr = notifyStr + "、" + this.notifyMode[i];
            });
            notifyStr = notifyStr.substring(1, notifyStr.length);
            item.notifyMode = notifyStr;
          });
          this.tData = data;
        })
        .catch(err => {
          console.error(err);
        });
    },
    e_search() {
      this.tResetPage();
      this.search();
    },
    e_edit(rowData) {
      AlarmSubscribeBiz.getGroup({ perPageCount: 500 }).then(data => {
        this.select_gourps = data.dataList.reduce((res, item) => {
          res[item.groupName] = item.groupName;
          return res;
        }, {});
        this.isAmend = rowData !== undefined;
        this.isDisabled = rowData !== undefined;
        this.dialogTitle =
          rowData !== undefined
            ? this.$t("alarmSubscribe.amendSubscribe")
            : this.$t("alarmSubscribe.addSubscribe");
        this.dialogFormVisible = true;
        if (rowData) {
          const row = extend(true, {}, rowData);
          row.enable =
            row.enable === this.$t("alarmSubscribe.yes") ? "true" : "false";
          row.notifyMode =
            row.notifyMode.length !== 0 ? row.notifyMode.split("、") : [];
          row.notifyMode.map((d, i) => {
            row.notifyMode[i] = getKeyByValue(this.notifyMode, d);
          });
          this.$nextTick(() => {
            // this.$refs.dynamicTable.setData(row.alarmLevelNotify);
            this.subScribeForm = { ...row };
          });
        } else {
          this.$nextTick(() => {
            // this.$refs.dynamicTable.setData([]);
            this.subScribeForm = {
              userName: "",
              email: "",
              phone: "",
              notifyMode: [],
              enable: "true",
              // remarks: "",
              groups: []
            };
          });
        }
      });
    },
    e_delete(rowData) {
      this.$confirm(this.$t("common.deleteTips"), this.$t("common.tips"), {
        type: "warning"
      })
        .then(() => {
          AlarmSubscribeBiz.deleteSubscribe({
            id: rowData.id
          }).then(data => {
            this.$message({
              message: this.$t("common.success"),
              type: "success"
            });
            this.search();
          });
        })
        .catch(() => {});
    },
    e_save() {
      this.$refs.subScribeForm.validate(valiid => {
        if (valiid) {
          // const alarmLevelNotify = extend(
          //   true,
          //   [],
          //   this.$refs.dynamicTable.getData()
          // );
          this.subScribeForm.enable = this.subScribeForm.enable === "true";
          const data = {
            ...extend(true, {}, this.subScribeForm)
            // alarmLevelNotify
          };
          if (this.isAmend) {
            AlarmSubscribeBiz.saveSubscribe(data).then(res => {
              this.successCallBack();
            });
          } else {
            AlarmSubscribeBiz.addSubscribe(data).then(res => {
              this.successCallBack();
            });
          }
        }
      });
    },
    successCallBack() {
      this.$message({
        message: this.$t("common.success"),
        type: "success"
      });
      setTimeout(() => {
        this.dialogFormVisible = false;
        this.search();
      }, 500);
    }
  },
  mounted() {
    this.e_init();
  }
};
</script>
        
<style>
.alaramSubscribe__content .alarmSubscribe__checkItem {
  margin-left: 0;
}
</style>